export default "__VITE_ASSET__CC4l6Ed5__"